import { Controller } from '@hotwired/stimulus'

// Settings shell sliders: keeps --range-fill on every range input so its track fills up to the thumb.
// A click refreshes too, because presets and "Match my Smart menu" set values without an input event.
export default class extends Controller {
  connect() {
    this.refresh = this.refresh.bind(this)
    this.refresh()
    ;['input', 'change', 'click'].forEach((type) => this.element.addEventListener(type, this.refresh))
  }

  disconnect() {
    ;['input', 'change', 'click'].forEach((type) => this.element.removeEventListener(type, this.refresh))
  }

  refresh() {
    this.element.querySelectorAll('input[type="range"]').forEach((input) => {
      const min = Number(input.min || 0)
      const max = Number(input.max || 100)
      const percent = max > min ? ((Number(input.value) - min) / (max - min)) * 100 : 0
      input.style.setProperty('--range-fill', `${percent}%`)
    })
  }
}
